import type { BrandFilterStateSet } from '../state/brand';
import {
  BrandFilterStateSet as BrandFilterStateSetSchema,
  BrandUuid as BrandUuidSchema,
} from '../state/brand';
import { Chunk, HashSet, pipe, Schema, String as Str, SchemaGetter } from 'effect';

const brandFilterStateSetToApiString = (brandSet: BrandFilterStateSet): string =>
  pipe(brandSet, Chunk.fromIterable, Chunk.join(','));

const apiStringToBrandFilterStateSet = (brandString: string): BrandFilterStateSet => {
  if (brandString === '') {
    return HashSet.empty();
  }

  return pipe(
    brandString,
    Str.split(','),
    Chunk.fromIterable,
    Chunk.filter((s) => s.length > 0),
    Chunk.map((s) => BrandUuidSchema.make(s)),
    HashSet.fromIterable
  );
};

export const BrandApiQuery = Schema.Struct({
  brand: Schema.optional(Schema.String),
});

export const BrandToApi = Schema.toType(BrandFilterStateSetSchema).pipe(
  Schema.decodeTo(BrandApiQuery, {
    decode: SchemaGetter.transform((brandSet) => {
      const brandString = brandFilterStateSetToApiString(brandSet);
      return brandString.length > 0 ? { brand: brandString } : {};
    }),
    encode: SchemaGetter.transform((apiData) =>
      apiStringToBrandFilterStateSet(apiData.brand ?? '')
    ),
  })
);
